export const ADMIN_LOGIN_REQUEST = 'ADMIN_LOGIN_REQUEST'
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'